module.exports = " <tr> <td> <span class=brand>{{ product.brand }}</span> <h4>{{ product.name }}</h4> <code>{{ product.upc_13 }}</code> </td> <td> {{ asCurrency(product.srp_amount) }} / {{ product.unit_of_measure | unit-of-measure 1 true }} </td> <td class=\"text-center toggle\"> <button type=button @click=toggleStockStatus() :class=\"{\n        'btn-success': !product.in_stock,\n        'btn-default': product.in_stock,\n      }\" class=\"btn btn-lg btn-toggle\"> <i class=\"fas fa-check\"></i> </button> </td> </tr> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductWithStock.vue
// module id = 369
// module chunks = 2